export default "__VITE_ASSET__BBuISE_w__"